/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

import autoTemplateComponent from './core/auto-template-component'
import carousel from './components/carousel'
import header from './components/header'
import fileUpload from './components/file'
import displayToggle from './utilities/displayToggle.js'

window.addEventListener('DOMContentLoaded', () => {
  autoTemplateComponent()
  header()
  carousel()
  fileUpload()

  displayToggle('#js-nav-about-us-button', '#js-menu-dropdown', 'hidden')

  displayToggle(
    '#js-nav-about-us-mobile-button',
    '#js-menu-mobile-dropdow',
    'hidden',
  )

  displayToggle(
    '#js-nav-mobile-button',
    '#js-nav-mobile-menu',
    'hidden',
    '#site-body',
  )

  displayToggle(
    '#js-location-switcher-left-button',
    '#js-location-switcher-left-dropdown',
    'hidden',
  )

  displayToggle(
    '#js-location-switcher-right-button',
    '#js-location-switcher-right-dropdown',
    'hidden',
  )

  displayToggle(
    '#js-nav-what-we-do-mobile-button',
    '#js-nav-key-pillars-mobile',
    'hidden',
  )

  displayToggle(
    '#js-lang-switcher-mobile-button',
    '#js-lang-switcher-mobile-dropdown',
    'hidden',
  )

  const globalToggleClose = () => {
    window.addEventListener('click', (e) => {
      const outermostElement = e.target.closest('[data-toggle]')

      if (outermostElement) return

      console.log(e.target)

      if (e.target.tagName === 'BUTTON') return

      const allToggleBtns = document.querySelectorAll('[data-btn-toggle]')

      allToggleBtns.forEach((elm) => {
        elm.classList.remove('is-active')
        elm.nextElementSibling.classList.add('hidden')
      })
    })
  }

  globalToggleClose()
})
